/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Send_PendingInputs */

const en_mail_admin_send_pending = /** @type {(inputs: Mail_Admin_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending is already in progress.`)
};

const de_mail_admin_send_pending = /** @type {(inputs: Mail_Admin_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versand läuft bereits.`)
};

/**
* | output |
* | --- |
* | "Sending is already in progress." |
*
* @param {Mail_Admin_Send_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_send_pending = /** @type {((inputs?: Mail_Admin_Send_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Send_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_send_pending(inputs)
	return en_mail_admin_send_pending(inputs)
});